/**
 * Created by oksuztepe on 09/01/17.
 */
export class NavigationEvent {
  constructor(public acton: string, public value: string) {
  }
}
